import {
    ErrorResponse,
    GetNeighborReportsRequest,
    GetTripsReportRequest,
    GetWeeklyReportsByOfficeRequest,
    GetWeeklyShiftsByDriverRequest,
    GoCancelsRow,
    NeighborPickupsList,
    NeighborsRequest,
    SetWeeklyDriverFeedbackFlagRequest,
    TripsReportsRow,
    TripsRequest,
    WeeklyDriverShiftsList,
    WeeklyDriverShiftsRow,
    WeeklyReportsList,
    WeeklyReportsOfficeRequest,
    WeeklyReportsRow,
    WeeklyShiftsDriverRequest,
} from "../../api";
import { DriverFeedbackFlagSetReq } from "../../api/models/DriverFeedbackFlagSetReq";
import { DriverFeedbackFlagSetResp } from "../../api/models/DriverFeedbackFlagSetResp";
import { getSessionCookie } from "../../components/cookies";
import {
    SelectedDriver,
    SelectedDriverDetailHeaderInfo,
    SetNeighborsInterface,
    TripDetails,
    TripReportsDict,
    detailSceenSlice,
} from "../../features/WeeklyReport/DetailScreen/store";
import { weeklyReportsSlice } from "../../features/WeeklyReport/store";
import { commonSlice, store } from "../../store";
import { dateToWeekYear } from "../../utils/time";
import { setSnackbarMsg, setSnackbarToggled } from "../common/common";
import { api } from "../common/make_api";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../common/send_log";
import { Logout } from "../login/login";
import { getGoCancelPositions } from "../shift_monitoring/trips/trip_reports";
import { findCorrectTrip } from "./map";

export const driverCellSnackbarAction = (flagOn: boolean): void => {
    setSnackbarToggled(true);
    const msg = flagOn ? "声かけ済みにしました" : "声かけを解除しました";
    setSnackbarMsg(msg);
};

export const setSnackbarMessage = (msg: string): void => {
    setSnackbarToggled(true);
    setSnackbarMsg(msg);
};

export const setViewingNonFeedbacked = (val: boolean): void => {
    store.dispatch(weeklyReportsSlice.actions.setViewingUnfeedbackedOnly(val));
};

export const setKoeKakeFlag = async (
    feedbackGiven: boolean,
    officeId?: number,
    driverId?: number,
    weekNo?: number,
    year?: number
): Promise<void> => {
    try {
        const state = store.getState();
        const weeklyState = state.weeklyReports;
        const detailState = state.detailScreen;

        let office = weeklyState.selectedOfficeId;
        let driver = detailState.selectedDriver?.driver_id;
        let week = detailState.detailHeaderInfo?.week_no;
        let yearNo = detailState.detailHeaderInfo?.year;

        if (officeId) {
            office = officeId;
        }
        if (driverId) {
            driver = driverId;
        }
        if (weekNo) {
            week = weekNo;
        }
        if (year) {
            yearNo = year;
        }
        if (!office || !driver || !week || !yearNo) {
            console.log("Cannot set driver_feedback flag.");
            return;
        }

        const request_body: DriverFeedbackFlagSetReq = {
            officeId: office,
            driverId: driver,
            weekNo: week,
            year: yearNo,
            feedbackGiven,
        };

        const req: SetWeeklyDriverFeedbackFlagRequest = {
            driverFeedbackFlagSetReq: request_body,
        };

        const res: DriverFeedbackFlagSetResp = await api
            .getWeeklyAPI()
            .setWeeklyDriverFeedbackFlag(req);

        sendLog(
            ResourceType.WEEKLY_REPORT,
            StatusType.FE_ACTION,
            ActionType.SET_DRIVER_PERFORMANCE_FEEDBACK,
            { set_to_status: feedbackGiven, driver_id: driver }
        );

        const avg_rev = detailState.detailHeaderInfo?.avg_revenue || -1;
        const comment = detailState.detailHeaderInfo?.comment || "";
        const off_avg = detailState.detailHeaderInfo?.office_avg_revenue || -1;
        const shifts = detailState.detailHeaderInfo?.shifts || -1;
        const worst_s = detailState.detailHeaderInfo?.worst_shift_id || "";
        const ff = feedbackGiven;
        const week_no = detailState.detailHeaderInfo?.week_no || -1;
        const yr = detailState.detailHeaderInfo?.year || -1;

        store.dispatch(
            detailSceenSlice.actions.setDriverDetailHeaderInfo({
                comment: comment,
                avg_revenue: avg_rev,
                office_avg_revenue: off_avg,
                shifts: shifts,
                worst_shift_id: worst_s,
                feedback_flag: ff,
                week_no: week_no,
                year: yr,
            })
        );

        selectWeeklyReports(weeklyState.viewingUnFeedbackedOnly);
    } catch (err) {
        console.log("Got this error from koekake flag:", err);
        if (err["status"] == 401) {
            console.log("Session has expired");
            Logout();
            return;
        }
        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
    }
};

export const getGoCancels = async () => {
    const state = store.getState();
    const detailState = state.detailScreen;
    const shiftId = detailState.selectedShiftId;
    const trip = detailState.selectedTripDetails;
    const trips = detailState.driverTripsByShift;

    if (!trip) {
        return;
    }

    const selectedTrip = findCorrectTrip(trip.trip_id, trips);
    if (!selectedTrip) {
        console.log("No trip selected.");
        store.dispatch(detailSceenSlice.actions.setGoCancels(null));
        return;
    }

    const loginSessionId = selectedTrip.loginSessionId;
    const unladenSessionId = selectedTrip.tripSessionId;

    if (!loginSessionId || !unladenSessionId) {
        console.log(
            "Weekly GoCancels: No loginSessionId or unladenSessionId provided.",
            loginSessionId,
            unladenSessionId
        );
        return;
    }

    const go_cancels_data: GoCancelsRow[] = await getGoCancelPositions(
        loginSessionId,
        unladenSessionId
    );

    store.dispatch(
        detailSceenSlice.actions.setGoCancels({
            shiftId: shiftId,
            data: go_cancels_data,
        })
    );
};

export const toggleNeighborsOn = async () => {
    const state = store.getState();
    const detailState = state.detailScreen;
    const neighborsOn = !detailState.neighborsViewingIsOn;
    store.dispatch(detailSceenSlice.actions.setNeighborsViewingOn(neighborsOn));
};

export const clearNeighborsOn = async () => {
    store.dispatch(detailSceenSlice.actions.setNeighborsViewingOn(false));
    store.dispatch(commonSlice.actions.clearMessage());
};

export const selectWeeklyFilterDriver = async (
    driverInfo: any
): Promise<void> => {
    store.dispatch(weeklyReportsSlice.actions.setSelectedDriver(driverInfo));
};

export const selectShiftId = async (shiftId: string): Promise<void> => {
    store.dispatch(detailSceenSlice.actions.setSelectedShiftId(shiftId));
};

export const selectTripDetails = async (
    tripId: string | undefined,
    tripStartTS: string | undefined
): Promise<void> => {
    if (!tripId || !tripStartTS) {
        return;
    }
    const trip: TripDetails = {
        trip_id: tripId,
        trip_start_ts: tripStartTS,
    };
    store.dispatch(detailSceenSlice.actions.setTrip(trip));
};

export const selectStartDate = async (startDate: string): Promise<void> => {
    store.dispatch(weeklyReportsSlice.actions.setStartDate(startDate));
};

// keep for now until move to MUI picker
export const calculateWeeksYearsFromDateRange = (
    start_date: string | null
): any => {
    if (!start_date) {
        return { weekNo: 0, yearNo: 0 };
    }
    return dateToWeekYear(start_date);
};

export const selectWeeklyReportsOfficeId = async (
    officeId: number | null
): Promise<void> => {
    store.dispatch(weeklyReportsSlice.actions.setSelectedOfficeId(officeId));
};

export const selectWeeklyReports = async (non_koekake_only?: boolean) => {
    store.dispatch(commonSlice.actions.startLoading());
    store.dispatch(weeklyReportsSlice.actions.setWeeklyReports(null));
    try {
        const state = store.getState();
        const weeklyState = state.weeklyReports;
        const selectedOfficeId = weeklyState.selectedOfficeId;

        const { weekNo, yearNo } = calculateWeeksYearsFromDateRange(
            weeklyState.selectedStartDate
        );

        const requestBody: WeeklyReportsOfficeRequest = {};

        if (!selectedOfficeId || !weekNo || !yearNo) {
            console.log(
                "One of selectedOfficeId, weekNo, or yearNo was not provided:",
                selectedOfficeId,
                weekNo,
                yearNo
            );
            return;
        }

        requestBody.officeId = selectedOfficeId;
        requestBody.officeIds = [selectedOfficeId];
        requestBody.weekNo = weekNo;
        requestBody.year = yearNo;

        const req: GetWeeklyReportsByOfficeRequest = {
            weeklyReportsOfficeRequest: requestBody,
        };

        const res: WeeklyReportsList = await api
            .getWeeklyAPI()
            .getWeeklyReportsByOffice(req);

        sendLog(
            ResourceType.WEEKLY_REPORT,
            StatusType.FE_ACTION,
            ActionType.GET_WEEKLY_REPORTS,
            { year: yearNo, week: weekNo, selectedOffice: selectedOfficeId }
        );

        const reports_list = res.reports ? res.reports : null;

        if (non_koekake_only) {
            const filtered = filterReportsForNonfeedbacked(res.reports);
            store.dispatch(
                weeklyReportsSlice.actions.setWeeklyReports(filtered)
            );
            return;
        }

        store.dispatch(
            weeklyReportsSlice.actions.setWeeklyReports(reports_list)
        );
    } catch (err) {
        console.log("Got this error from weekly_drivers:", err);
        if (err["status"] == 401) {
            console.log("Session has expired");
            Logout();
            return;
        }

        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return null;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return null;
        }
        const res = (await (err as Response).json()) as ErrorResponse;
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
};

const filterReportsForNonfeedbacked = (
    reports: WeeklyReportsRow[] | undefined
): WeeklyReportsRow[] | null => {
    if (!reports) {
        return null;
    }
    const nonFb = reports.filter((x: WeeklyReportsRow) => {
        return !x.feedbackGivenFlag;
    });
    return nonFb;
};

export const selectDriverDetailHeaderInfo = async (
    comment: string,
    avg_revenue: number,
    office_avg_revenue: number,
    shifts: number,
    worst_shift_id: string,
    feedback_flag: boolean,
    week_no: number,
    year: number
): Promise<void> => {
    const headerInfo = {
        comment,
        avg_revenue,
        office_avg_revenue,
        shifts,
        worst_shift_id,
        feedback_flag,
        week_no,
        year,
    } as SelectedDriverDetailHeaderInfo;
    store.dispatch(
        detailSceenSlice.actions.setDriverDetailHeaderInfo(headerInfo)
    );
};

export const resetSelectedDriverDetailInfo = async () => {
    store.dispatch(detailSceenSlice.actions.resetState());
};

export const setNeedUpdateFlag = async (set_flag: boolean) => {
    store.dispatch(weeklyReportsSlice.actions.setNeedUpdateFlag(set_flag));
};

export const selectDetailScreenDriver = async (
    driverId: number,
    driverCode: string,
    driverName: string
): Promise<void> => {
    const driver = {
        driver_id: driverId,
        driver_code: driverCode,
        driver_name: driverName,
    } as SelectedDriver;
    store.dispatch(detailSceenSlice.actions.setSelectedDriver(driver));
};

export const getShiftsPerDriver = async (): Promise<void> => {
    store.dispatch(commonSlice.actions.startLoading());

    try {
        const state = store.getState();
        const weeklyState = state.weeklyReports;
        const detailState = state.detailScreen;

        const selectedOfficeId = weeklyState.selectedOfficeId;
        const { weekNo, yearNo } = calculateWeeksYearsFromDateRange(
            weeklyState.selectedStartDate
        );

        const selectedDriver = detailState.selectedDriver;

        if (!selectedDriver || !selectedOfficeId) {
            console.log(
                "One of selectedDriver or selectedOfficeId was not provided:",
                selectedDriver,
                selectedOfficeId
            );
            return;
        }

        const requestBody: WeeklyShiftsDriverRequest = {
            officeId: selectedOfficeId,
            driverId: selectedDriver.driver_id,
            weekNo: weekNo,
            year: yearNo,
            officeIds: [selectedOfficeId],
        };

        const req: GetWeeklyShiftsByDriverRequest = {
            weeklyShiftsDriverRequest: requestBody,
        };
        const res: WeeklyDriverShiftsList = await api
            .getWeeklyAPI()
            .getWeeklyShiftsByDriver(req);

        sendLog(
            ResourceType.WEEKLY_DETAIL,
            StatusType.FE_ACTION,
            ActionType.GET_WEEKLY_DETAIL,
            { year: yearNo, week: weekNo, selectedOffice: selectedOfficeId }
        );

        const reports_list = res.reports ? res.reports : null;
        store.dispatch(detailSceenSlice.actions.setDetailReports(reports_list));
        const initialSelectedTrip = getWorstTripPerShift();
        selectTripDetails(
            initialSelectedTrip?.trip_id,
            initialSelectedTrip?.trip_start_ts
        );
        getTripsPerShifts();
        getGoCancels();
        getNeighborsPerTrip();
    } catch (err) {
        console.log("Got this error from weekly shifts:", err);
        if (err["status"] == 401) {
            console.log("Session has expired");
            Logout();
            return;
        }
        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
};

export const turnNeighborSwitchOff = () => {
    store.dispatch(detailSceenSlice.actions.setNeighborsViewingOn(false));
};

export const turnNeighborSwitchOn = () => {
    store.dispatch(detailSceenSlice.actions.setNeighborsViewingOn(true));
};

export const getNeighborsPerTrip = async () => {
    store.dispatch(commonSlice.actions.startLoading());

    try {
        const state = store.getState();
        const detailState = state.detailScreen;
        const weeklyState = state.weeklyReports;

        if (!getSessionCookie().consoleUserPermissions.includes("neighbors")) {
            return;
        }

        const selectedOfficeId = weeklyState.selectedOfficeId;
        const selectedTrip = detailState.selectedTripDetails;
        const neighborsOn = detailState.neighborsViewingIsOn;

        if (!selectedTrip || !selectedOfficeId) {
            console.log(
                "No trip or office_id was selected...",
                selectedTrip,
                selectedOfficeId
            );
            return null;
        }

        const requestBody: NeighborsRequest = {
            officeId: selectedOfficeId,
            unladenTripSessionId: selectedTrip.trip_id,
            unladenStartTs: selectedTrip.trip_start_ts,
        };

        const req: GetNeighborReportsRequest = {
            neighborsRequest: requestBody,
        };

        const res: NeighborPickupsList = await api
            .getShiftReportsAPI()
            .getNeighborReports(req);

        console.debug("Weekly neighbors for trip: ", res, selectedTrip);

        const errorMsg = validateNeighborReports(res);

        store.dispatch(detailSceenSlice.actions.setLastNeighborsMsg(errorMsg));

        store.dispatch(
            detailSceenSlice.actions.setNeighborsPerTrip({
                tripId: selectedTrip.trip_id,
                shiftId: detailState.selectedShiftId,
                neighbors: res.neighborReports,
            } as SetNeighborsInterface)
        );

        return res;
    } catch (err) {
        console.log("Got this error from weekly neighbors:", err);
        if (err["status"] == 401) {
            Logout();
            return;
        }
        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
};

export const resetNeighborsData = () => {
    store.dispatch(detailSceenSlice.actions.setNeighborsPerTrip(null));
};

export const setExpandedContainerName = async (
    containerName: string | null
): Promise<void> => {
    store.dispatch(
        detailSceenSlice.actions.setExpandedContainerName(containerName)
    );
    store.dispatch(
        detailSceenSlice.actions.setExpandedContainers([containerName])
    );
};

export const setNeighborsErrorMsgIfExists = async () => {
    store.dispatch(commonSlice.actions.clearMessage());
    let errorMsg: any = null;
    const state = store.getState();
    const detailState = state.detailScreen;
    if (detailState.lastNeighborsMessage) {
        errorMsg = detailState.lastNeighborsMessage;
    }

    if (errorMsg) {
        setSnackbarMessage(errorMsg);
    }
};

const validateNeighborReports = (
    reports: NeighborPickupsList
): string | null => {
    const neighbors = reports.neighborReports ? reports.neighborReports : [];

    let errorMsg: null | string = null;

    if (neighbors.length == 0) {
        errorMsg = "情報提供期間外です。";
    }

    const _notcreated = neighbors.filter((x) => {
        return x.neighborPickupStatus == "data_not_created";
    });

    if (_notcreated.length > 0) {
        errorMsg = "データ生成前です。乗務の2日後から確認出来ます。";
    }

    // no_neighbor_pickupが一つでも存在する場合、そのMSGを優先して表示
    const _noneighbor = neighbors.filter((x) => {
        return x.neighborPickupStatus == "no_neighbor_pickup";
    });

    const _pickup = neighbors.filter((x) => {
        return x.neighborPickupStatus == "neighbor_pickup_found";
    });

    if (_noneighbor.length > 0 && _pickup.length === 0) {
        errorMsg = "他車両実績が存在しません。";
    }

    return errorMsg;
};

export const getWorstTripPerShift = (): TripDetails | null => {
    const state = store.getState();
    const detailState = state.detailScreen;
    const selectedShift = detailState.selectedShiftId;
    const shifts = detailState.detailReports;

    if (!selectedShift || !shifts) {
        console.log(
            "No shift selected or no shifts available:",
            selectedShift,
            shifts
        );
        return null;
    }

    let worstTrip: TripDetails | null = null;

    for (let i = 0; i < shifts.length; i++) {
        const _shift = shifts[i];
        if (_shift.shiftId == selectedShift) {
            const tripId = _shift.worstUnladenTripSessionId;
            const tripStartTs = _shift.worstUnladenStartTs;
            if (!tripId || !tripStartTs) {
                continue;
            }
            worstTrip = { trip_id: tripId, trip_start_ts: tripStartTs };
        }
    }
    return worstTrip;
};

export const getTripsPerShifts = async () => {
    store.dispatch(commonSlice.actions.startLoading());

    try {
        const state = store.getState();
        const weeklyState = state.weeklyReports;
        const detailState = state.detailScreen;
        const selectedDriver = detailState.selectedDriver;
        const selectedOfficeId = weeklyState.selectedOfficeId;
        const shiftReports = detailState.detailReports;
        if (!selectedDriver || !selectedOfficeId || !shiftReports) {
            console.log(
                "One of selectedDriver, selectedOfficeId, or shiftReports was not selected:",
                selectedDriver,
                selectedOfficeId,
                shiftReports
            );
            return null;
        }

        const shiftIds = shiftReports.map((x: WeeklyDriverShiftsRow) => {
            const shiftId = x.shiftId ? x.shiftId : "";
            return shiftId;
        });

        if (!shiftReports) {
            return;
        }

        const reqBody: TripsRequest = {
            officeId: selectedOfficeId,
            driverId: selectedDriver.driver_id,
            officeIds: [selectedOfficeId],
        };

        if (shiftIds) {
            reqBody.getShiftIds = shiftIds;
        }

        const req: GetTripsReportRequest = {
            tripsRequest: reqBody,
        };

        const res = await api.getShiftReportsAPI().getTripsReport(req);

        if (res.trips) {
            const filteredTrips = filterOutHoming(res.trips);

            store.dispatch(
                detailSceenSlice.actions.setDriverTrips(filteredTrips)
            );
        }
    } catch (err) {
        console.log("Got this error from weekly trips:", err);
        if (err["status"] == 401) {
            Logout();
            return;
        }
        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
};

const filterOutHoming = (trips: TripsReportsRow[]) => {
    const filtered = trips.filter((x: TripsReportsRow) => {
        return x.boardingType !== "homing";
    });
    return filtered;
};

export const organizeTripsByShift = (
    trips?: TripsReportsRow[]
): TripReportsDict | null => {
    if (!trips) {
        return null;
    }
    const result = trips.reduce((r, a) => {
        if (!a.shiftId) {
            return;
        }
        r[a.shiftId] = r[a.shiftId] || [];
        r[a.shiftId].push(a);
        return r;
    }, Object.create(null));
    return result;
};
